import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const DEFAULT_ALLSERVICELOGO = '/img/all_service_icon.svg'

const AllServiceWrapper = styled(Box)`
  ${({ theme }) => `
    position: relative;
    width: 100%;
    height: 96px;
    cursor: pointer;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%), 0 2px 12px 0 rgb(0 0 0 / 5%);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;

    &:active {
      box-shadow: 0 0px 0px 0 transparent;
      border: 1px solid ${theme.palette.background.line};
    }

    ${theme.breakpoints.up('sm')} {
      border-radius: 24px;   
      margin-bottom: 24px;
    }

    ${theme.breakpoints.up('md')} {
      width: 100%;
      height: 112px;
    }

    ${theme.breakpoints.up('lg')} {
      width: 140px;
      height: 140px;
      margin-bottom: 0px;

      &:hover {
        box-shadow: 0 0px 0px 0 transparent;
        border: 1px solid ${theme.palette.background.line};
      }
    }

    ${theme.breakpoints.up('xl')} {
      width: 164px;
      height: 164px;  
    }

    ${theme.breakpoints.up('xxl')} {
      width: 218px;
      height: 218px;
    }
  `}
`

const AbsoluteBox = styled(Box)`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`

const AllServiceMobileCard = ({ openAllServiceModal }) => {
  return (
    <AllServiceWrapper onClick={openAllServiceModal}>
      <img width={24} height={24} src={DEFAULT_ALLSERVICELOGO} />
      <Typography
        variant="subtitle2"
        color="textMinus2"
        ml={4}
        sx={{ whiteSpace: 'nowrap' }}
      >
        全部服務
      </Typography>
    </AllServiceWrapper>
  )
}

const AllServiceDesktopCard = ({ openAllServiceModal }) => {
  return (
    <AllServiceWrapper onClick={openAllServiceModal}>
      <AbsoluteBox>
        <img width={48} height={48} src={DEFAULT_ALLSERVICELOGO} />
        <Typography
          variant="subtitle2"
          color="textMinus2"
          mt={{ xs: 4, xl: 6, xxl: 12 }}
          sx={{ whiteSpace: 'nowrap' }}
        >
          全部服務
        </Typography>
      </AbsoluteBox>
    </AllServiceWrapper>
  )
}

const AllServiceCard = ({ openAllServiceModal }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <>
      {isDesktop ? (
        <AllServiceDesktopCard openAllServiceModal={openAllServiceModal} />
      ) : (
        <AllServiceMobileCard openAllServiceModal={openAllServiceModal} />
      )}
    </>
  )
}

export default AllServiceCard
